<div class="sidebar-container" #sidebarPanel>
  <div class="sidebar h-100">
    @for (button of buttons; track button) {
      @if (button.shouldDisplay == undefined || button.shouldDisplay == true) {
        <a
          class="sidebar-btn"
          (click)="selectComponent(button)"
          [ngClass]="{ active: selectedComponent == button.componentName }"
          [suiTooltipPlacement]="!isRtl ? 'start' : 'end'"
          suiTooltip="{{ button.label }}"
        >
          <fa-icon [icon]="button.icon"></fa-icon>
          @if (button.counter > 0) {
            <app-counter-badge [count]="button.counter"></app-counter-badge>
          }
        </a>
      }
    }
  </div>
  <app-sidebar-panel
    [isOpen]="isOpen"
    [title]="selectedComponentTitle"
    [icon]="selectedComponentIcon"
  ></app-sidebar-panel>
</div>
